import {IChatSocketCommand} from "../../../../../app/types/ChatSocketCommand";

export const notifyChatChangeStatusCommand = (): IChatSocketCommand => ({
    cmd: 'status_all'
});